import { createSlice } from "@reduxjs/toolkit";
import { updateReleaseDocumentStatusAPI } from "../../services/releaseDocAPIs";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const createOrUpdateReleaseDocSlice = createSlice({
  name: "createOrUpdateReleaseDoc",
  initialState: data,
  reducers: {
    createOrUpdateReleaseDocInfo(state) {
      state.isLoading = true;
    },
    createOrUpdateReleaseDocSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    createOrUpdateReleaseDocFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    createOrUpdateReleaseDocReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const createOrUpdateReleaseDocHandler = (data) => async (dispatch) => {
  try {
    dispatch(createOrUpdateReleaseDocAction.createOrUpdateReleaseDocInfo());
    const response = await updateReleaseDocumentStatusAPI(data);
    dispatch(createOrUpdateReleaseDocAction.createOrUpdateReleaseDocSuccess(response));
  } catch (e) {
    dispatch(createOrUpdateReleaseDocAction.createOrUpdateReleaseDocFailure(e));
  }
};
export default createOrUpdateReleaseDocSlice.reducer;
export const createOrUpdateReleaseDocAction = createOrUpdateReleaseDocSlice.actions;
